import { Link } from "react-router-dom";
import { Radar, RefreshCw, CheckCircle2, Clock3, SearchX, AlertCircle } from "lucide-react";
import { toast } from "sonner";

const STYLE = {
  ACTIVE: { icon: CheckCircle2, cls: "border-emerald-500/40 bg-emerald-500/10 text-emerald-300", pill: "ACTIVE" },
  PENDING: { icon: Clock3, cls: "border-amber-500/40 bg-amber-500/10 text-amber-200", pill: "PENDING" },
  DOT_ONLY: { icon: Clock3, cls: "border-amber-500/40 bg-amber-500/10 text-amber-200", pill: "DOT ONLY" },
  NOT_FOUND: { icon: SearchX, cls: "border-white/15 bg-white/5 text-white/70", pill: "NOT FOUND" },
  ERROR: { icon: AlertCircle, cls: "border-red-500/40 bg-red-500/10 text-red-200", pill: "RETRYING" },
};

const ago = (iso) => {
  const t = new Date(iso).getTime();
  if (!iso || Number.isNaN(t)) return "just now";
  const m = Math.max(0, Math.round((Date.now() - t) / 60000));
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  return h < 24 ? `${h} hr ago` : `${Math.round(h / 24)} day${h >= 48 ? "s" : ""} ago`;
};

export function AuthorityWatchRow({ user, hasNumber, watch, checkNow, checking }) {
  if (!hasNumber) return null;
  if (!user) {
    return (
      <div className="flex items-start gap-2 text-sm mt-3 rounded-xl border border-white/10 bg-white/[0.03] px-3.5 py-3 text-white/60" data-testid="authority-watch-anon">
        <Radar className="w-4 h-4 mt-0.5 text-[#FF5A1F] shrink-0" />
        <span>Want us to check FMCSA every day and text you the moment this flips ACTIVE? <Link to="/signup" className="text-[#FF5A1F] font-bold hover:underline">Create a free account</Link>.</span>
      </div>
    );
  }
  const s = STYLE[watch?.status] || STYLE.PENDING;
  const Icon = s.icon;
  const run = async () => {
    const r = await checkNow();
    if (r.ok) toast.success(r.watch.status === "ACTIVE" ? "Authority is ACTIVE 🎉" : `FMCSA says: ${r.watch.label}`);
    else toast.error(r.error);
  };
  return (
    <div className={`flex flex-wrap items-center gap-x-3 gap-y-2 text-sm mt-3 rounded-xl border px-3.5 py-3 ${s.cls}`} data-testid="authority-watch">
      <Icon className="w-4 h-4 shrink-0" />
      <span className="text-[10px] font-black tracking-widest rounded-full border border-current/40 px-2 py-0.5" data-testid="authority-watch-status">{watch ? s.pill : "WATCHING"}</span>
      <span className="flex-1 min-w-[200px] text-white/80">
        {watch ? (
          <>{watch.legal_name && <b className="text-white">{watch.legal_name} · </b>}{watch.label}<span className="text-white/45"> · checked {ago(watch.checked_at)}</span></>
        ) : (
          <>MC Auto-Watch is on — we check FMCSA daily and text you the moment it flips ACTIVE.</>
        )}
      </span>
      {watch?.status !== "ACTIVE" && (
        <button
          type="button" onClick={run} disabled={checking || watch?.can_check_now === false}
          className="inline-flex items-center gap-1.5 rounded-full border border-current/40 px-3 py-1 text-xs font-bold hover:bg-white/10 transition-colors disabled:opacity-50"
          data-testid="authority-watch-check-now"
        >
          <RefreshCw className={`w-3 h-3 ${checking ? "animate-spin" : ""}`} /> {checking ? "Checking…" : "Check now"}
        </button>
      )}
    </div>
  );
}
